import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";

export const useAuth = () => {
  const {data: user, isLoading} = useQuery({
    ...trpc.auth.me.queryOptions(),
    retry: false,
    staleTime: Infinity,
  });

  return {
    user,
    isLoading,
    isAuthenticated: Boolean(user),
  };
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    ...trpc.auth.logout.mutationOptions(),
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      queryClient.setQueryData(trpc.auth.me.queryOptions().queryKey, null as any);
    },
  });
};
